export default "__VITE_ASSET__DOnYxjeE__"